// Danışman yüzeyi not penceresi (modal): onay kuyruğu satırı ve Özet "Yanıt bekleyen notlar" listesi
// bir hücrenin iş parçacığını burada açar ("Yanıtla" alanıyla). Hücre ızgarası dışında çapa hücre
// olmadığı için popover yerine KpiModal kullanılır (Esc / odak tuzağı / odak iadesi hazır).

import type { NoteCellRef } from "../../api/kpi-notes";
import { KPI_NOTES_COPY } from "../../lib/kpi-notes-copy";
import { KpiCellNotes } from "./KpiCellNotes";
import { KpiModal } from "./KpiModal";

export function KpiNoteThreadModal(props: {
  open: boolean;
  title: string;
  setId: string;
  cell: NoteCellRef;
  onClose: () => void;
  onChanged: () => void;
}): JSX.Element | null {
  const C = KPI_NOTES_COPY.internal;
  return (
    <KpiModal
      open={props.open}
      title={props.title}
      width={520}
      onClose={props.onClose}
      footer={
        <button
          type="button"
          onClick={props.onClose}
          className="px-3 py-1.5 rounded-lg text-sm"
          style={{ border: "1px solid var(--color-border)", color: "var(--color-text-2)" }}
        >
          {C.close}
        </button>
      }
    >
      <KpiCellNotes
        audience="internal"
        setId={props.setId}
        cell={props.cell}
        composer
        autoFocus
        onChanged={props.onChanged}
      />
    </KpiModal>
  );
}
